import { Model } from '../abstracts/model';
import { CategoryModel } from './category.model';
import { ProductFilterModel } from './product-filter.model';

export class ProductModel extends Model {
  id: number;
  slug: string;
  title: string;
  description: string;
  priceUah: number;
  priceUahOld: number;
  thumbnail: string;
  images: string[];
  filters: ProductFilterModel[];
  category: CategoryModel;

  override onInit(): void {
    if (this.category) {
      this.category = new CategoryModel(this.category);
    }
    if (!this.thumbnail) {
      this.thumbnail = '/assets/img/thumbnail.webp';
    }
  }
}
